import {
  CurrentSessionFragment,
  CurrentSessionQuery,
  useCurrentSessionQuery,
} from 'src/graphql/generated';
import { DefaultQueryOptions } from './types';

type QueryOptions<Data = CurrentSessionQuery> = DefaultQueryOptions<
  CurrentSessionQuery,
  Data
>;

export const useCurrentSession = <Data = CurrentSessionQuery['session']>(
  options?: Omit<QueryOptions<Data>, 'initialData' | 'queryKey' | 'select'> & {
    select?: (data: CurrentSessionFragment) => Data;
  },
) => {
  const { select: userSelect, ...restOptions } = options ?? {};

  return useCurrentSessionQuery(undefined, {
    select: (data) => {
      const session = data.session;
      // If user provided a custom select, apply it to the organization data
      // Otherwise return organization as-is
      return userSelect
        ? userSelect(session)
        : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          (session as unknown as Data);
    },
    staleTime: Infinity,
    ...restOptions,
  });
};
